import { ISubscriptionPlan, ISubscriptionPlansState } from 'models/subscriptionplans';
import { Dispatch } from 'react-redux';
import { IStore } from 'redux/IStore';

/** Action Types */
export const REQUEST_START: string = 'subscriptionplans/REQUEST_START';
export const REQUEST_FAILURE: string = 'subscriptionplans/REQUEST_FAILURE';
export const RESET_DATA: string = 'subscriptionplans/RESET_DATA';
export const SET_PLANS: string = 'subscriptionplans/SET_PLANS';

interface ISubscriptionPlansAction {
	type: string;
	payload?: {
		message?: any;
		plans?: ISubscriptionPlansState['plans'];
	};
}

/** Initial State */
const getinitialState = (): ISubscriptionPlansState => ({
	plans: null,
});

/** Reducer */
export function subscriptionPlansReducer(
	state = getinitialState(),
	action: ISubscriptionPlansAction,
): ISubscriptionPlansState {
	switch (action.type) {
		case REQUEST_START:
			return {
				...state,
				isFetching: true,
				error: false,
				message: undefined,
			};

		case SET_PLANS:
			return {
				...state,
				isFetching: false,
				error: false,
				message: undefined,
				plans: action.payload.plans,
			};

		case REQUEST_FAILURE:
			return {
				...state,
				isFetching: false,
				error: true,
				message: action.payload.message,
			};

		case RESET_DATA:
			return getinitialState();

		default:
			return state;
	}
}

export function requestStart(): ISubscriptionPlansAction {
	return {
		type: REQUEST_START,
	};
}

export function resetData(): ISubscriptionPlansAction {
	return {
		type: RESET_DATA,
	};
}

export function setPlans(plans: ISubscriptionPlansState['plans']): ISubscriptionPlansAction {
	return {
		type: SET_PLANS,
		payload: {
			plans,
		},
	};
}

export function requestFailure(message: any): ISubscriptionPlansAction {
	return {
		type: REQUEST_FAILURE,
		payload: {
			message,
		},
	};
}

export function getSubscriptionPlans() {
	return (dispatch: Dispatch<IStore>, getState: () => IStore) => {
		dispatch(requestStart());

		return fetch(
			getState().fetchDefault.baseAPI + 'api/SubscriptionPlan',
			Object.assign({}, getState().fetchDefault.requestInit),
		)
			.then((res) => {
				if (res.ok) {
					return res.json().then((json) => {
						dispatch(setPlans(json));
						return { error: false };
					});
				} else {
					dispatch(requestFailure(res.statusText));
					return { error: true };
				}
			})
			.catch((e) => {
				console.error(e);
				return { error: true };
			});
	};
}

export function postSubscriptionPlan(plan: ISubscriptionPlan) {
	return (dispatch: Dispatch<IStore>, getState: () => IStore) => {
		dispatch(requestStart());

		return fetch(
			getState().fetchDefault.baseAPI + 'api/SubscriptionPlan',
			Object.assign({}, getState().fetchDefault.requestInit, {
				method: 'POST',
				body: JSON.stringify(plan),
			}),
		).then((res) => {
			if (res.ok) {
				return dispatch(getSubscriptionPlans());
			} else {
				dispatch(requestFailure(res.statusText));
				return { error: true };
			}
		});
	};
}

export function putSubscriptionPlan(plan: ISubscriptionPlan) {
	return (dispatch: Dispatch<IStore>, getState: () => IStore) => {
		dispatch(requestStart());

		return fetch(
			getState().fetchDefault.baseAPI + `api/SubscriptionPlan/${plan?.id}`,
			Object.assign({}, getState().fetchDefault.requestInit, {
				method: 'PUT',
				body: JSON.stringify(plan),
			}),
		).then((res) => {
			if (res.ok) {
				return dispatch(getSubscriptionPlans());
			} else {
				dispatch(requestFailure(res.statusText));
				return { error: true };
			}
		});
	};
}

export function deleteSubscriptionPlan(plan: ISubscriptionPlan) {
	return (dispatch: Dispatch<IStore>, getState: () => IStore) => {
		dispatch(requestStart());

		return fetch(
			getState().fetchDefault.baseAPI + `api/SubscriptionPlan/${plan?.id}`,
			Object.assign({}, getState().fetchDefault.requestInit, {
				method: 'DELETE',
			}),
		).then((res) => {
			if (res.ok) {
				return dispatch(getSubscriptionPlans());
			} else {
				dispatch(requestFailure(res.statusText));
				return { error: true };
			}
		});
	};
}
